import { compose, withProps } from 'recompose'
import { connect } from 'react-redux'
import { forceHistory } from 'src/composables'
import { getCurrentPath } from 'src/helpers/browser'
import withOnClickCloseLoans from 'src/composables/withOnClickCloseLoans'
import { selectClientFetchId } from 'src/store/selectors/client'
import { selectHomeFetchId, getStreet } from 'src/store/selectors/home'
import { startCase } from 'src/store/selectors/utils'
import { PATH_HELPERS } from 'src/constants/navigation'

const HomeLinkContainer = compose(
  forceHistory,
  connect(state => ({
    currentClientId: selectClientFetchId(state),
    currentHomeId: selectHomeFetchId(state)
  })),
  withProps(({ home, currentClientId, currentHomeId }) => {
    const path = getCurrentPath()

    return {
      active: home.id === currentHomeId && !path.endsWith('/home/new'),
      to: PATH_HELPERS.home.buildPath(currentClientId, home.id),
      children: startCase(getStreet(home))
    }
  }),
  withOnClickCloseLoans
)

export default HomeLinkContainer
